import React from 'react';
// import { Button } from '@material-ui/core';
import SmileDesignHTML from '../../../SmileDesign/SmileDesignHTML';
import { useLang } from '../../../../util/lang';
import { ApiServerUrl } from '../../../../config.json';
// import { smileDesignProductList } from '../../../../store/SmileDesign/SmileDesignSlice';

const SmileDesignPlan = ({ useStyles, currentTreatmentPlan, patientInfo, commentSidebarGridStyle }) => {
    const get = useLang('PatientInfo');

    const classes = useStyles();
    return (
        <div className={classes.root} style={{ display: 'flex', flexDirection: 'column', ...commentSidebarGridStyle}}>
            {/* <p style={{ fontWeight: 'bold', fontSize: '16px', margin: '0px', marginBottom: '10px' }}>
                {get('@PatientInfo.smileDesign.exocadPre')}
            </p> */}

            <SmileDesignHTML
                link={ApiServerUrl + currentTreatmentPlan?.['smileDesign_exocad_pre']?.substring(1)}
                height={'100%'}
            />

            {/* {[smileDesignProductList.full.type].includes(patientInfo.case_type) && (
                <Button
                    disabled={!currentTreatmentPlan['smileDesignPPT']}
                    variant="contained"
                    onClick={() => {
                        window.open(ApiServerUrl + currentTreatmentPlan['smileDesignPPT'].substring(1), '_parent');
                    }}
                >
                    {get('@PatientInfo.smileDesign.downloadSmileReport')}
                </Button>
            )} */}
        </div>
    );
};

export default SmileDesignPlan;
